<template>
   <el-form ref="formValidate" :model="params" label-width="100px" :rules="rules">
        <el-form-item prop="parentId" :label="$t('department.parentDept')" v-show="!isUpdate">
          <el-input v-model="parent.name" style="width:200px;" disabled></el-input>
        </el-form-item>
        <el-form-item prop="name" :label="$t('department.deptName')">
            <el-input type="text" v-model="params.name" :placeholder="$t('common.nameRequire')" style="width:200px;"> </el-input>
        </el-form-item>
        <el-form-item prop="status" :label="$t('department.deptStatus')">
          <zk-dictionary-select type="status" v-model="params.status" style="width:200px;" :placeholder="$t('common.select')">
          </zk-dictionary-select>
        </el-form-item>
        <el-form-item prop="value" :label="$t('common.remark')">
          <el-input type="text" v-model="params.remark" :placeholder="$t('common.remarkRequire')" style="width:200px;"> </el-input>
        </el-form-item>
  </el-form>
</template>
<script>
import * as orgService from '../../../services/organization'
export default {
  name: 'zk-dept-save-or-update',
  props: ['form', 'isUpdate'],
  data () {
    let checkStatus = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('common.statusRequire')))
      } else {
        callback()
      }
    }
    let rules = {
      name: [{ required: true, message: this.$t('common.nameRequire'), trigger: 'blur' }],
      status: [{ required: true, validator: checkStatus, trigger: 'blur' }]
    }
    return {
      rules,
      params: {},
      parent: {}
    }
  },
  methods: {
    save () {
      return new Promise((resolve, reject) => {
        this.$refs.formValidate.validate(valid => {
          if (valid) {
            if (this.isUpdate) {
              resolve(orgService.update(this.params))
            } else {
              resolve(orgService.add(this.params))
            }
          } else {
            reject(valid)
          }
        })
      })
    },
    resetFields () {
      this.$refs.formValidate.resetFields()
    }
  },
  watch: {
    form (newVal, oldVal) {
      if (newVal && this.isUpdate) {
        this.params = JSON.parse(JSON.stringify(this.form))
      } else {
        this.parent = JSON.parse(JSON.stringify(this.form))
        this.params = {
          parentId: this.parent.id
        }
      }
    },
    isUpdate (newValue) {
      if (newValue) {
        this.params = JSON.parse(JSON.stringify(this.form))
      } else {
        this.parent = JSON.parse(JSON.stringify(this.form))
        this.params = {
          parentId: this.parent.id
        }
      }
    }
  },
  mounted () {
    if (this.isUpdate) {
      this.params = JSON.parse(JSON.stringify(this.form))
    } else {
      this.parent = JSON.parse(JSON.stringify(this.form))
      this.params = {
        parentId: this.parent.id
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/departmentSaveOrUpdate/src/main.vue